import LayoutContainer from "../../../components/Containers/LayoutContainer"
import '@fortawesome/fontawesome-free/css/all.min.css';
import React from "react"
import "./corporateCommunication.scss";

const CorporateCommunication: React.FunctionComponent = () => {

    return (
      <LayoutContainer title="corporate-communication">
        <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
         <h2>
          <i className="page-header-icon fa fa-home">
            
          </i>
          Corporate Communication
         </h2>
  
        </div>
      </LayoutContainer>
    );
  };
  

export default CorporateCommunication;